<template>
  <div>
    <el-footer :class="isSpcial ? 'isHigher' : ''" style="margin-top: 26rem">
      <div class="footer1">
        <div class="Globalcontainer">
          <img src="../assets/Home/组 23378@2x.png" alt="" />
          <div>
            关于我们
            <span>|</span>
            鹤壁技术转移中心<span>|</span>郑州航空港科技成果转移转化公共服务平台
          </div>
        </div>
      </div>
      <div class="footer2">
        <div class="Globalcontainer">
          <div class="containers">
            <div>
              <span> 企业邮箱 <span class="yould">hnppcjszy@163.com</span> </span>
              <span style="width: 21rem">
                线上平台咨询 <span>0371-67579156</span>
              </span>
            </div>
            <div class="bottom">
              <span> 邮政编码 <span>450001</span> </span>
              <span>
                单位地址 &nbsp;
                <span class="add">
                  中国河南省郑州市高新技术开发区翠竹街6号</span
                >
              </span>
            </div>
          </div>
          <div>
            <!-- <img src="../assets/Home/" alt="" /> -->
            <br />
            关注微信公众号
          </div>
        </div>
      </div>
      <div class="footer3">
        豫ICP备2024064350号-5 &nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span style="width: 20.75rem">
          技术支持： 河南八六三软件股份有限公司
        </span>
      </div>
    </el-footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    spcial: {
      type: Boolean,
    },
  },
  data() {
    return {
      isRegister: false,
      isSpcial: false,
    };
  },
  created() {
    this.isSpcial = this.spcial;
  },
};
</script>

<style lang='scss' scoped>
.el-footer {
  height: 21.875rem !important;
  padding: 0;
  margin: 0;

  background: #222a3d;
  .footer1 {
    height: 5.8125rem;
    background: rgba(63, 73, 97, 0.48);

    div {
      padding-top: 0.375rem;
      img {
        width: 32rem;
      }
      div {
        cursor: pointer;
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.5);
        span {
          cursor: pointer;
          margin: 0 0.625rem;
        }
      }
    }
  }
  .footer2 {
    .Globalcontainer {
      font-size: 0.875rem;
      color: rgba(255, 255, 255, 0.5);
      height: auto;
      padding: 3.5625rem 0 3.1875rem 0;
      border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.2);
      .containers {
        height: 5.0625rem;
        width: 47.1875rem;
        text-align: left;
        div {
          display: flex;
          justify-content: space-between;
          span {
            min-width: 15.25rem;
            display: inline-block;
            span {
              display: inline;
              font-size: 1.25rem;
              color: #fff;
              font-weight: 500;
              margin-left: 1.25rem;
            }
          }
        }
        .bottom {
          margin-top: 1.5625rem;
          .add {
            color: #ffffff;
          }
        }
      }
    }
  }
  .footer3 {
    height: 4.1875rem;
    font-size: 1rem;
    font-family: PingFangSC-Regular;
    line-height: 4.1875rem;
    color: #ffffff;
    opacity: 0.5;
  }
}
.isHigher {
  margin-top: 32rem !important;
}
</style>